<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal">
          <div class="modal-img">
            <!--            <div class="swiper-container">-->
            <swiper-component :popupList="props.data" />
            <!--              <div class="swiper-slide">-->
            <!--                <div class="img-con">-->
            <!--                  &lt;!&ndash;인라인 스타일의 배경색은 임의, 개발시 삭제 요망&ndash;&gt;-->
            <!--                  <img src="static/sample/img_popup_sample.png" alt="sample" />-->
            <!--                  &lt;!&ndash;이미지 비율 - 가로 3: 세로 4 (최소 300px * 400px)&ndash;&gt;-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="swiper-pagination">-->
            <!--                <div class="swiper-pagination-bullets swiper-pagination-bullets-active"></div>-->
            <!--                <div class="swiper-pagination-bullets"></div>-->
            <!--                <div class="swiper-pagination-bullets"></div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn gray" style="padding: 1.2rem 0;" @click="fnNotShowToday">오늘 하루 보지 않기</button>
              <button class="btn black" @click.prevent="$emit('close')">닫기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'POPUP',
  props: {
    data: {
      type: [Object],
      default: () => {}
    }
  },
  emits: ['close']
};
</script>
<script setup>
import SwiperComponent from '@/components/common/layouts/swiper/popup.vue';
import { useStore } from 'vuex';
const { dispatch } = useStore();
import { defineProps, getCurrentInstance } from 'vue';
import dayjs from 'dayjs';
const { proxy } = getCurrentInstance();

const props = defineProps({
  data: {
    type: [Array, Object],
    default: () => {}
  }
});

const fnNotShowToday = async () => {
  const today = new dayjs();
  const todayDate = today.format('YYYY-MM-DD');
  const tomorrowDate = today.add(1, 'day').format('YYYY-MM-DD');
  await dispatch('home/fetchTomorrowDate', tomorrowDate);
  proxy.$emit('close');
};
</script>
